import React from 'react';
import logo from '../../assets/img/56.png';
import estudianteImg from '../../assets/img/Estudiante.png';
import cursosImg from '../../assets/img/55.png';
import admisionImg from '../../assets/img/Admision.png';

const LandingPage = ({ setCurrentPage }) => {
    const options = [
        {
            id: 'estudiante',
            title: 'Estudiante Regular',
            subtitle: 'Ya soy estudiante',
            buttonText: 'Ingresa aqui',
            image: estudianteImg,
            action: () => setCurrentPage('login')
        },
        {
            id: 'cursos',
            title: 'Cursos de Extensión',
            subtitle: 'Inscríbete en nuestros cursos de extensión',
            buttonText: 'Ver Cursos',
            image: cursosImg,
            action: () => setCurrentPage('cursos-extension-publicos')
        },
        {
            id: 'admision',
            title: 'Modalidad de Admisión',
            subtitle: 'Quiero ser estudiante',
            buttonText: 'Ingresa aqui',
            image: admisionImg,
            action: () => setCurrentPage('registro-preadmision')
        }
    ];

    return (
        <div className="min-h-screen bg-white">
            {/* Header azul oscuro */}
            <div className="bg-[#1e3a8a] h-3"></div>

            <div className="container mx-auto px-4 py-8 md:py-12">
                <div className="max-w-5xl mx-auto">
                    {/* Logo y Título centrados */}
                    <div className="text-center mb-10 md:mb-14">
                        <div className="flex justify-center items-center gap-4 mb-2">
                            <img
                                src={logo}
                                alt="EBID Logo"
                                className="w-20 h-20 md:w-28 md:h-28 object-contain"
                            />
                            <div className="text-left">
                                <h1 className="text-xl md:text-2xl font-bold text-[#2c3e7d]">Sistema Académico</h1>
                                <p className="text-[#2c3e7d] text-xs md:text-sm text-right">Escuela Boliviana</p>
                                <p className="text-[#2c3e7d] text-xs md:text-sm text-right">Intercultural de Danza</p>
                            </div>
                        </div>
                    </div>

                    {/* Título de bienvenida */}
                    <div className="text-center mb-8 md:mb-12">
                        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                            Bienvenido al Sistema Académico
                        </h2>
                        <p className="text-gray-600 text-sm md:text-base">
                            Elige cómo deseas ingresar
                        </p>
                    </div>

                    {/* Cards de opciones */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                        {options.map((option) => (
                            <div
                                key={option.id}
                                className="bg-white rounded-2xl border-2 border-gray-200 p-6 md:p-8 flex flex-col items-center text-center hover:shadow-xl hover:border-[#1e3a8a]/30 transition-all duration-300 cursor-pointer group"
                                onClick={option.action}
                            >
                                {/* Imagen */}
                                <div className="mb-4 md:mb-6 h-24 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                                    <img
                                        src={option.image}
                                        alt={option.title}
                                        className="max-h-24 w-auto object-contain"
                                    />
                                </div>

                                {/* Título */}
                                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">
                                    {option.title}
                                </h3>

                                {/* Subtítulo - con flex-grow para que empuje el botón hacia abajo */}
                                <p className="text-gray-500 text-sm mb-6 flex-grow">
                                    {option.subtitle}
                                </p>

                                {/* Botón - siempre al final */}
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        option.action();
                                    }}
                                    className="w-full bg-[#1e3a8a] text-white py-3 px-6 rounded-full hover:bg-[#2c4a9a] transition font-semibold text-sm md:text-base shadow-md mt-auto"
                                >
                                    {option.buttonText}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Link para personal administrativo */}
                <div className="text-center mt-12 pt-8 border-t border-gray-200">
                    <button
                        onClick={() => setCurrentPage('login')}
                        className="text-gray-500 text-sm hover:text-[#1e3a8a] transition"
                    >
                        Personal Administrativo - Iniciar Sesión
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
